import { createFileRoute } from '@tanstack/react-router'
import OrganizationSettings from '@/pages/settings/organization'

export const Route = createFileRoute(
  '/(protected)/settings/organization'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <OrganizationSettings />
}
